<myp-inline-loader [loading]="loading" height="400px" spinnerName="fileDetailLoader"></myp-inline-loader>
@if (!loading) {
  <div class="container file-detail-page m-t-10">
    <div class="row">
      <div class="col-md-3 col-2 d-flex align-items-center">
        <a [routerLink]="['/workspaces/detail/' + file.workspace_id + '/files']" class="m-r-5"><fa-icon icon="arrow-left" class="circle-icon-btn back-btn"></fa-icon></a>
        <span class="fui-heading-font t-12 text-truncate d-block">
          @if (screenWidth > 767) {
            {{ file.workspace.name }}
          }
        </span>
      </div>
      <div class="col-md-6 col-8 text-center">
        @if (file.type != "stems") {
          <h4 class="fui-heading-font text-truncate">{{ file.format_grouping_id ? file.name_no_extension : file.filename }}</h4>
        }
        @if (file.type == "stems" && file.grouped_files && file.grouped_files.length > 1 && waveformComments) {
          <div class="position-relative">
            <span class="t-16 bold c-pink">{{ file.grouped_files.length + " files in this Stem Upload" }}</span>
            &nbsp;&nbsp;&nbsp;
            <button (click)="selectingStemFile = !selectingStemFile" class="small-btn med pink m-0">
              <fa-icon [icon]="'chevron-down'"></fa-icon>
              {{ "com.select_active_stem" | translate }}
            </button>
            <span class="d-block t-16 bold fui-heading-font text-truncate multiple" (click)="selectingStemFile = !selectingStemFile">{{ waveformComments?.selectedWaveformFile?.filename }}</span>
            @if (selectingStemFile) {
              <div class="position-absolute w-full stem-selector animate-in-down">
                <ul>
                  @for (gFile of file.grouped_files; track gFile) {
                    <li [class.selected]="gFile.id == waveformComments.selectedWaveformFile.id" (click)="waveformComments.selectWaveformFile(gFile); selectingStemFile = false">
                      {{ gFile.filename }}
                      <br />
                      @if (waveformComments.stemCommentCounts[gFile.id]) {
                        <span class="stem-comment-count">
                          {{ waveformComments.stemCommentCounts[gFile.id] + " comment" + (waveformComments.stemCommentCounts[gFile.id] > 1 ? "s" : "") }}
                        </span>
                      }
                    </li>
                  }
                </ul>
                <fa-icon icon="times" class="top-right-close" (click)="selectingStemFile = false"></fa-icon>
              </div>
            }
          </div>
        }
      </div>
      <div class="col-md-3 col-sm-2 d-none d-sm-block text-right" style="text-align: right">
        <span class="btn btn-secondary" (click)="file.type == 'stems' ? downloadStems() : downloadFile()">
          {{ (file.type == "stems" ? "com.download_all_stems" : "download.download") | translate }}
        </span>
      </div>
    </div>
    <div class="row m-t-20">
      @if (workspaceService.audioFiles[file.extension]) {
        <div class="col-md-12">
          <myp-waveform-comments
            #waveformComments
            [file]="smallestFile ? smallestFile : file"
            [public]="false"
            [collaboratorMap]="collaboratorMap"
            (waveformSelected)="checkPublicLinkAvailability()"
          ></myp-waveform-comments>
        </div>
      }
    </div>
    <div class="row" [class.m-t-40]="workspaceService.audioFiles[file.extension]" #chatView [ngStyle]="{ height: chatViewHeight + 'px' }">
      <div class="d-block d-md-none col-12 m-b-5">
        <myp-segmented-bar [white]="true" (selected)="displayedFileSection = $event.name; measureUI()" [options]="fileSections"></myp-segmented-bar>
      </div>
      @if (displayedFileSection == "File Discussion" || screenWidth > 767) {
        <div class="col-md-8 position-relative">
          <myp-chat
            [height]="chatViewHeight"
            #chatCmp
            [admin]="isWorkspaceOwner"
            (editMessage)="editMsg($event)"
            (deleteMessage)="deleteMsg($event)"
            (messageSent)="addMessage($event)"
            [mentionDataSource]="collabsNotMe"
            [messages]="communityService.comments"
            [participantMap]="collaboratorMap"
          ></myp-chat>
          @if (!communityService.comments || !communityService.comments.length) {
            <div style="position: absolute; width: 96%; top: 40%; display: flex; align-items: center; justify-content: center">
              @if (!loadingFileThreadMessages) {
                <span class="gothic text-center" [innerHTML]="'com.file_convo_desc' | translate | safe: 'html'"></span>
              }
              @if (loadingFileThreadMessages) {
                <span class="gothic text-center">{{ "general.loading_dots" | translate }}</span>
              }
            </div>
          }
        </div>
      }
      @if (uiReady && (screenWidth > 767 || displayedFileSection == "File Details" || displayedFileSection == "Timestamped Comments")) {
        <div
          class="col-md-4 filedetail-sidebar"
          [class.isAudio]="workspaceService.audioFiles[file.extension]"
          [class.hasStems]="file.type == 'stems' && file.grouped_files && file.grouped_files.length > 1"
        >
          @if (this.workspaceService.audioFiles[file.extension]) {
            <div class="d-none d-md-block m-t-5">
              <myp-segmented-bar [white]="true" (selected)="displayedFileSection = $event.name" [options]="truncatedFileSections"></myp-segmented-bar>
            </div>
          }
          <div class="sidebar-content">
            @if (displayedFileSection == "File Details" || !this.workspaceService.audioFiles[file.extension]) {
              @if (workspaceService.imageFiles[file.extension]) {
                <img [src]="file.url" class="w-full border-radius10" />
              }
              @if (workspaceService.videoFiles[file.extension]) {
                <video width="100%" [src]="file.url" controls></video>
              }
              @if (appService.isChrome && file.extension == "mov") {
                <span class="t-12 text-muted">
                  {{ "com.mov_file_warning" | translate }}
                </span>
              }
              @if (file.description) {
                <div class="m-y-20 border-bottom p-b-20">{{ file.description }}</div>
              }
              @if (!file.format_grouping_id) {
                <div class="file-metadata">
                  <div class="d-flex justify-content-between m-t-10 t-14 p-b-10 border-bottom gothic">
                    <span>{{ "com.date_added" | translate }}</span>
                    <span>{{ (waveformComments && waveformComments.selectedWaveformFile ? waveformComments.selectedWaveformFile.date_created : file.date_created) | date }}</span>
                  </div>
                  <div class="d-flex justify-content-between m-t-10 t-14 p-b-10 border-bottom gothic">
                    <span>{{ "com.extension" | translate }}</span>
                    <span>{{ (waveformComments && waveformComments.selectedWaveformFile ? waveformComments.selectedWaveformFile.extension : file.extension) | uppercase }}</span>
                  </div>
                  <div class="d-flex justify-content-between m-t-10 t-14 p-b-10 border-bottom gothic">
                    <span>{{ "com.filename" | translate }}</span>
                    <span>{{ waveformComments && waveformComments.selectedWaveformFile ? waveformComments.selectedWaveformFile.filename : file.filename }}</span>
                  </div>
                  <div class="d-flex justify-content-between m-t-10 t-14 p-b-10 border-bottom gothic">
                    <span>{{ "com.filesize" | translate }}</span>
                    <span>{{ (waveformComments && waveformComments.selectedWaveformFile ? waveformComments.selectedWaveformFile.filesize : file.filesize) | bytesToSize }}</span>
                  </div>
                </div>
              }
              @if (file.format_grouping_id) {
                <div class="file-metadata">
                  <div class="d-flex justify-content-between m-t-10 t-14 p-b-10 border-bottom gothic">
                    <span>{{ "com.date_added" | translate }}</span>
                    <span>{{ file.date_created | date }}</span>
                  </div>
                  <div class="d-flex justify-content-between m-t-10 t-14 p-b-10 border-bottom gothic">
                    <span>{{ "com.extension" | translate }}</span>
                    <div>
                      @for (item of file.formats; track item) {
                        <span class="m-r-5">{{ item.extension | uppercase }}</span>
                      }
                    </div>
                  </div>
                  <div class="d-flex justify-content-between m-t-10 t-14 p-b-10 border-bottom gothic">
                    <span>{{ "com.filename" | translate }}</span>
                    <span>{{ file.formats && file.formats.length > 1 ? file.name_no_extension : file.filename }}</span>
                  </div>
                  <div class="d-flex justify-content-between m-t-10 t-14 p-b-10 border-bottom gothic">
                    <span>{{ "com.filesize" | translate }}</span>
                    <div>
                      @for (item of file.formats; track item) {
                        <span class="d-block">{{ item.extension + ": " + (item.filesize | bytesToSize) }}</span>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (!file.format_grouping_id && (waveformComments?.selectedWaveformFile?.public_link || file.public_link)) {
                <div class="gothic m-t-20 t-12 m-b-20">
                  <ng-container
                    *ngTemplateOutlet="publicLinkDetails; context: { public_link: waveformComments ? waveformComments?.selectedWaveformFile?.public_link : file.public_link }"
                  ></ng-container>
                  <ng-template #publicLinkDetails let-public_link="public_link">
                    <h4 class="section-header is-grid d-none d-md-block">Shareable Link</h4>
                    @if (!public_link.expired) {
                      <div class="text-left">
                        <a target="_blank" class="d-block m-y-10 t-16 brandfont-bold" [href]="env.fenderUrl + 'share/' + public_link.hash">{{ env.fenderUrl }}share/{{ public_link.hash }}</a>
                        <span class="t-12 d-block m-b-10">{{ public_link.expiration_date ? "Expires: " + (public_link.expiration_date | date) : "Does Not Expire" }}</span>
                        @if (collaboratorMap[user.id].role == "owner" || collaboratorMap[user.id].role == "admin") {
                          <label for="public_link_comments_toggle" class="d-flex align-items-center">
                            <myp-switch extraClasses="m-b-10" [active]="public_link.show_comments" label="Allow Comments" [labelToRight]="true" (toggle)="togglePublicLinkComments()"></myp-switch>
                          </label>
                        }
                        <div class="d-flex align-items-center m-b-20">
                          <button (click)="copyLink(env.fenderUrl + 'share/' + public_link.hash)" class="brand-btn-reverse sm m-r-10">{{ copied ? "Copied!" : "Copy to Clipboard" }}</button>
                          <button (click)="sharePublicLinkInCommunity(public_link.hash)" class="brand-btn-reverse sm m-r-10">Share Link in Community</button>
                          <button (click)="deletePublicLink()" class="small-btn red">Delete</button>
                        </div>
                      </div>
                    }
                    @if (public_link.expired) {
                      <div class="text-left d-flex align-items-center m-b-20">
                        <span class="t-12 c-red m-r-10">Link expired.</span>
                        @if (collaboratorMap[user.id].role == "owner" || collaboratorMap[user.id].role == "admin") {
                          <button (click)="renewPublicLink()" class="brand-btn-reverse sm m-r-10">Renew</button>
                        }
                        @if (collaboratorMap[user.id].role == "owner" || collaboratorMap[user.id].role == "admin") {
                          <button (click)="deletePublicLink()" class="small-btn red">Delete</button>
                        }
                      </div>
                    }
                  </ng-template>
                </div>
              }
              @if (file.format_grouping_id && file.formats && file.formats.length > 1) {
                <div class="gothic m-t-20 t-12 m-b-20">
                  <h4 class="section-header is-grid d-none d-md-block" style="margin: 0px 0px 5px 0px">Shareable Links</h4>
                  @for (item of file.formats; track item) {
                    @if (item.public_link) {
                      <span class="t-16 bold">Shareable Link for {{ item.extension.toUpperCase() }} format</span>
                      @if (!item.public_link.expired) {
                        <div class="text-left">
                          <a target="_blank" class="d-block m-y-10" [href]="env.fenderUrl + 'share/' + item.public_link.hash">{{ env.fenderUrl }}share/{{ item.public_link.hash }}</a>
                          <span class="t-12 d-block m-b-10">{{ item.public_link.expiration_date ? "Expires: " + (item.public_link.expiration_date | date) : "Does Not Expire" }}</span>
                          @if (collaboratorMap[user.id].role == "owner" || collaboratorMap[user.id].role == "admin") {
                            <label for="public_link_comments_toggle" class="d-flex align-items-center">
                              <myp-switch
                                extraClasses="m-b-10"
                                [active]="item.public_link.show_comments"
                                label="Allow Comments"
                                [labelToRight]="true"
                                (toggle)="togglePublicLinkComments(item)"
                              ></myp-switch>
                            </label>
                          }
                          <div class="d-flex align-items-center m-b-20">
                            <button (click)="copyLink(env.fenderUrl + 'share/' + item.public_link.hash)" class="brand-btn-reverse sm m-r-10">{{ copied ? "Copied!" : "Copy to Clipboard" }}</button>
                            <button (click)="sharePublicLinkInCommunity(item.public_link.hash)" class="brand-btn-reverse sm m-r-10">Share Link in Community</button>
                            <button (click)="deletePublicLink(item)" class="small-btn red">Delete</button>
                          </div>
                        </div>
                      }
                      @if (item.public_link.expired) {
                        <div class="text-left d-flex align-items-center m-b-20">
                          <span class="t-12 c-red m-r-10">Link expired.</span>
                          @if (collaboratorMap[user.id].role == "owner" || collaboratorMap[user.id].role == "admin") {
                            <button (click)="renewPublicLink(item)" class="brand-btn-reverse sm m-r-10">Renew</button>
                          }
                          @if (collaboratorMap[user.id].role == "owner" || collaboratorMap[user.id].role == "admin") {
                            <button (click)="deletePublicLink(item)" class="small-btn red">Delete</button>
                          }
                        </div>
                      }
                    }
                  }
                </div>
              }
              @if (collaboratorMap[user.id].role == "owner" || collaboratorMap[user.id].role == "admin") {
                @if (shouldShowPublicLinkButton) {
                  <button class="brand-btn-reverse d-block gothic m-t-10 w-full" (click)="createPublicLink()">
                    {{ "sphere.workspaces.create_shareable_link" | translate }}
                  </button>
                }
              }
              <button class="brand-btn-reverse d-block gothic m-t-10 w-full" (click)="downloadFile()">{{ "com.download_file" | translate }}</button>
              @if (user.active_subscription) {
                <button class="brand-btn-reverse d-block gothic m-t-10 w-full" (click)="shareInCommunity()">
                  {{ "sphere.workspaces.share_file_in_community" | translate }}
                </button>
              }
            }
            @if (displayedFileSection == "Timestamped Comments") {
              @if (workspaceService.audioFiles[file.extension]) {
                <div>
                  @if (!waveformComments?.parentAudioComments?.length) {
                    <div class="m-t-50">
                      <fa-icon icon="comments" class="c-pink t-50"></fa-icon>
                      <br />
                      <fui-heading [text]="'Timestamped Comments'" [level]="5"></fui-heading>
                    </div>
                  }
                  <div class="m-t-10">Click on the waveform above to add comments at specific times in the audio file.</div>
                  @if (file.type != "mixdown" && file.grouped_files && file.grouped_files.length > 1) {
                    <div class="text-center w-full">
                      <span class="d-inline-block m-t-10 t-12 bold gothic">{{ "com.commenting_on" | translate | uppercase }}</span>
                      <div class="text-truncate">
                        <span class="t-14 c-pink gothic">{{ waveformComments?.selectedWaveformFile?.filename }}</span>
                      </div>
                      <button (click)="selectingStemFile = !selectingStemFile" class="small-btn pink m-0">{{ "com.select_active_stem" | translate }}</button>
                    </div>
                  }
                  @if (waveformComments && waveformComments.parentAudioComments && waveformComments.parentAudioComments.length) {
                    @for (comment of waveformComments.parentAudioComments; track comment) {
                      <div
                        class="p-b-20 inline-audio-comment-list-item"
                        [class.active]="waveformComments.hoveringCommentPhoto && waveformComments.hoveringCommentPhoto.key == comment.key"
                        [id]="comment.key"
                        (mouseenter)="inlineCommentHoverEnter(comment)"
                        (mouseleave)="inlineCommentHoverLeave(comment)"
                      >
                        <ng-container *ngTemplateOutlet="inlineAudioCommentListItem; context: { comment: comment }"></ng-container>
                        <div class="m-l-20">
                          @for (reply of waveformComments.parentThreadMap[comment.key]; track reply) {
                            <div class="m-y-10 reply inline-audio-comment-list-item">
                              <ng-container *ngTemplateOutlet="inlineAudioCommentListItem; context: { comment: reply }"></ng-container>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
}

<ng-template #inlineAudioCommentListItem let-comment="comment">
  @if (comment.timestamp) {
    <div class="t-14 gothic font-weight-bold c-light-blue m-y-10 brandfont-bold">
      {{ "com.comment_at_time" | translate: { time: hhmmss(comment.timestamp.time) } }}
    </div>
  }
  <div class="d-flex align-items-center">
    <img
      [src]="collaboratorMap[comment.user_id] && collaboratorMap[comment.user_id].photo ? collaboratorMap[comment.user_id].photo : './assets/images/default_avatar.jpg'"
      style="width: 14px; height: 14px; border-radius: 7px; margin-right: 5px"
    />
    <div>
      <span class="d-block t-12 c-gray">{{ (comment.created.toDate() | date: "MMM Do [at] hh:mm" : true) + " " + collaboratorMap[comment.user_id]?.name }}</span>
    </div>
  </div>
  <div class="t-14 waveform-inline-comment-msg">{{ comment.message }}</div>
  <div class="d-flex">
    @if (!comment.parentID) {
      <button class="small-btn m-r-5 d-block text-center" (click)="waveformComments.playAtTime(comment.timestamp.time, comment)">
        <fa-icon icon="play"></fa-icon>
        {{ "com.play_from_here" | translate }}
      </button>
    }
    @if (!comment.parentID) {
      <button class="small-btn m-r-5 d-block text-center" (click)="waveformComments.displayAudioComment(comment)">{{ "com.reply" | translate }}</button>
    }
    @if (comment.user_id == user.id) {
      <button class="d-block small-btn" (click)="waveformComments.msgOptions(comment)">{{ "sphere.options" | translate }}</button>
    }
  </div>
</ng-template>
